import domainConfig from 'app/PoC/DataGridDemoPages/ActivityRecordsDemo/ActivityRecordDemo.config'
import SkyNetObjectProfile from '../components/SkyNetObjectProfile'
import {
    DataGridSupportedFeatures,
} from '../components/SkyNetMasterDataGrid/SkyNetMasterDataGrid.types'

const featuresLists = [DataGridSupportedFeatures.ShowArchived]

const ActivityRecordsDemoPage = () => {
    return (
        <SkyNetObjectProfile
            config={domainConfig}
            featuresLists={featuresLists}
        />
    )
}

export default ActivityRecordsDemoPage
